/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useGetUserGroupsQuery } from "../../../../../../redux/apiSlice";
import { SearchBar } from "../../SearchBar";
import { AsideMenu } from "../AsideMenu";

export const UserGroupMenu = ({ destination = "/user-groups/view", actionsMenu }) => {
    const { isFetching, data: userGroups } = useGetUserGroupsQuery()

    const [search, setSearch] = useState("");
    const ActionsMenu = actionsMenu;

    const UserGroupList = userGroups?.filter((val) =>
        val.name?.toLowerCase().includes(search?.toLowerCase())
    );

    return (
        <div className="d-flex flex-column h-100">
            <SearchBar
                placeholder={"Search User Groups"}
                isLoading={isFetching}
                onInput={(e) => setSearch(e.target.value.trim())}
            />

            <div className="h-100 overflow-auto">
                {
                    UserGroupList?.map((userGroup, i) => (
                        <AsideMenu.NavItem to={`${destination}/${userGroup?.groupId}`} key={i}>
                            {`${userGroup?.name}`.substring(0, 20)}
                        </AsideMenu.NavItem>
                    ))
                }
            </div>

            {
                actionsMenu && <ActionsMenu/>
            }
        </div>
    );
}
